const DEFAULT_GA_MEASUREMENT_IDS = ['G-BD4MF7SM6X', 'G-G5DSGM78J3']

/** GTM 커스텀 이벤트 이름 (태그 관리자 트리거와 동일) */
export const GTM_EVENTS = {
    PAGE_VIEW: 'page_view',
    CONTACT_SUBMIT: 'contact_submit',
    KAKAO_CONSULT_CLICK: 'kakao_consult_click',
}

/**
 * @param {string | undefined} raw
 * @returns {string[]}
 */
function parseCommaSeparatedIds(raw) {
    if (!raw?.trim()) {
        return DEFAULT_GA_MEASUREMENT_IDS
    }

    const ids = raw
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)

    return ids.length > 0 ? ids : DEFAULT_GA_MEASUREMENT_IDS
}

/** GA4 측정 ID (쉼표로 여러 개). REACT_APP_GA_MEASUREMENT_ID 미설정 시 기본값 사용 */
export const GA_MEASUREMENT_IDS = parseCommaSeparatedIds(process.env.REACT_APP_GA_MEASUREMENT_ID)

/** GTM 컨테이너 ID (예: GTM-XXXXXXX). 설정 시 GTM 스니펫 로드 */
export const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_ID?.trim() || ''

/**
 * @returns {object[] | null}
 */
function getDataLayer() {
    if (typeof window === 'undefined') {
        return null
    }

    window.dataLayer = window.dataLayer || []
    return window.dataLayer
}

/**
 * GTM dataLayer 커스텀 이벤트
 * @param {string} event
 * @param {Record<string, unknown>} [params]
 */
export function pushGtmEvent(event, params = {}) {
    const dataLayer = getDataLayer()
    if (!dataLayer) {
        return
    }

    dataLayer.push({
        event,
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_title: document.title,
        ...params,
    })
}

/**
 * gtag 이벤트 (GA4 직접 연동 시)
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackGaEvent(eventName, params = {}) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return
    }

    window.gtag('event', eventName, params)
}

/**
 * SPA 라우트 변경 시 page_view
 * @param {string} pathname
 */
export function trackPageView(pathname) {
    if (typeof window === 'undefined') {
        return
    }

    const pagePath = pathname || window.location.pathname

    pushGtmEvent(GTM_EVENTS.PAGE_VIEW, {
        page_path: pagePath,
        page_location: `${window.location.origin}${pagePath}${window.location.search}`,
    })

    if (typeof window.gtag !== 'function') {
        return
    }

    for (const id of GA_MEASUREMENT_IDS) {
        window.gtag('config', id, { page_path: pagePath })
    }
}

/** @deprecated trackPageView 사용 */
export const trackGaPageView = trackPageView

/**
 * 문의 폼 제출 성공
 * @param {{ method?: string, company?: string }} [params]
 */
export function trackContactSubmit(params = {}) {
    const payload = {
        form_name: 'contact',
        submission_method: params.method || 'unknown',
        ...(params.company ? { company: params.company } : {}),
    }

    pushGtmEvent(GTM_EVENTS.CONTACT_SUBMIT, payload)
    trackGaEvent(GTM_EVENTS.CONTACT_SUBMIT, payload)
}

/**
 * 카카오톡 채널 상담 클릭
 * @param {{ source?: string }} [params]
 */
export function trackKakaoConsultClick(params = {}) {
    const payload = {
        click_source: params.source || 'unknown',
    }

    pushGtmEvent(GTM_EVENTS.KAKAO_CONSULT_CLICK, payload)
    trackGaEvent(GTM_EVENTS.KAKAO_CONSULT_CLICK, payload)
}
